import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-uploading-processor',
  templateUrl: './uploading-processor.component.html',
  styleUrls: ['./uploading-processor.component.scss'],
  standalone: false
})
export class UploadingProcessorComponent {
  @Input() progress: number;
  @Input() progressMessage: string;
}
